<div class="flex-main-container">
  <div class="container main-container">
    <div class="row">
      <div *ngIf="generalTmsError.length > 0 && !visualIdsForm.valid"
          class="col-xs-12 general-error"
          role="alert">
          <wdpr-messages [values]="generalTmsError"></wdpr-messages>
      </div>
      <div class="col-xs-12 title">
        <h1>{{ 'link-page.title' | translate }}</h1>
        <span class="visible-xs hidden-sm">
          {{ 'link-page.description' | translate }}
        </span>
      </div>
    </div>
    <div class="row main-content">
      <div class="col-xs-12 col-sm-offset-1 col-sm-6 col-sm-push-5">
        <app-carousel [slides]="carouselSlides"></app-carousel>
      </div>
      <div class="col-xs-12 col-sm-5 col-sm-pull-7 vid-form-container">
        <span class="hidden-xs">
          {{ 'link-page.description' | translate }}
        </span>
        <form class="vid-form" #visualIdsForm="ngForm">
          <div class="input-container" *ngFor="let entitlement of entitlements; let i = index;">
            <wdpr-input customAriaLabel="{{ 'link-page.input-placeholder' | translate }} {{ i }}"
                        label="{{ 'link-page.input-placeholder' | translate }}"
                        name="entitlementId_{{ entitlement.id }}"
                        [maxlength]="vidInputLength.max"
                        [(ngModel)]="entitlement.entitlementId"
                        [visualIdList]="entitlements"
                        [visualIdIndex]="i"
                        class="guestSensitive"
                        [ngClass]="{'invalid': vidInput.invalid, 'has-icon': shouldShowIconContainer(vidInput)}"
                        required
                        appDuplicatedVisualIdValidator
                        ngDefaultControl
                        pattern="[0-9\s]+"
                        #vidInput="ngModel"
                        tabindex="1"
                        #vidInputsRef>
            </wdpr-input>
            <span *ngIf="shouldShowIconContainer(vidInput)" class="input-actions">
              <a *ngIf="vidInput.status !== 'PENDING'"
                 class="di di16 di-close-button"
                 (click)="removeVisualIdInput(i)"
                 (keyup.enter)="removeVisualIdInput(i)"
                 routerLink=""
                 tabindex="0"
                 role="button"
                 [attr.aria-label]="'link-page.aria-label-remove-vid' | translate"
                 tabindex="1">
              </a>
            </span>
            <div *ngIf="vidInput.invalid && vidInput.touched"
              role="alert">
              <span *ngIf="vidInput.errors" class="error-message">
                <span class="di di-alert"></span>
                {{ getVisualIdInputErrorKey(vidInput.errors) | translate }}
              </span>
            </div>
          </div>
        </form>
        <div class="links">
          <a routerLink=""
            [ngClass]="{'disabled': !canAddMoreVisualIds()}"
            (click)="addVisualId()"
            tabindex="1"
            [attr.aria-disabled]= "!canAddMoreVisualIds()"
            analyticsTrackLink='{"linkId":"{{&apos;{{&apos;}}LOB}}_TicketAPSpecialEventClaim_AddID","store":"{{&apos;{{&apos;}}LOB}}{{&apos;{{&apos;}}storeType}}"}'>
              <span class="di di16 di-add-button"></span>
              {{ 'link-page.add-numbers-cta' | translate }}
          </a>
          <a *ngIf="displayClaimLink()"
            href="{{ mepClaimUrl }}"
            tabindex="1">
            <span class="di di16 glyphicon-chevron-up"></span>
            {{ 'link-page.link-mep-cta' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
  <app-pep-syndicated-footer></app-pep-syndicated-footer>
  <div class="container-fluid navbar-fixed-bottom">
    <div class="container">
      <div class="row">
        <div class="col-xs-6">
          <wdpr-button theme="secondary"
                       (click)="onCancel()"
                       tabindex="3"
                       analyticsTrackLink='{"linkId":"{{&apos;{{&apos;}}LOB}}_TicketAPSpecialEventClaim_Cancel","store":"{{&apos;{{&apos;}}LOB}}{{&apos;{{&apos;}}storeType}}"}'>
            {{ 'link-page.cancel-cta' | translate }}
          </wdpr-button>
        </div>
        <div class="col-xs-6 text-right">
          <wdpr-button theme="primary"
                       (click)="validateEntitlements()"
                       [disabled]="isValidationInProgress || !visualIdsForm.valid"
                       tabindex="3"
                       analyticsTrackLink='{"linkId":"{{&apos;{{&apos;}}LOB}}_TicketAPSpecialEventClaim_Continue","store":"{{&apos;{{&apos;}}LOB}}{{&apos;{{&apos;}}storeType}}"}'>
            <span *ngIf="!isValidationInProgress">{{ 'link-page.continue-cta' | translate }}</span>
            <wdpr-loading *ngIf="isValidationInProgress" size="small"></wdpr-loading>
          </wdpr-button>
        </div>
      </div>
    </div>
  </div>
</div>
